import React from "react";
import styled from "styled-components";
import MultipleLocationsTable from "./MultipleLocationsTable";
import NewSubmissionsTable from "./NewSubmissionsTable";
import NewMembersTable from "./NewMembersTable";

const Wrapper = styled.div`
  padding: 12px;
  background: #eeeeee;
  border-radius: 8px;
`;

const MultipleLocationView = ({ data, submissionsType }) => (
  <Wrapper>
    <MultipleLocationsTable
      companyName={data?.company_name}
      engagementType={submissionsType}
      locations={data?.managed_locations}
    />
    <div style={{ height: 16 }} />
    <NewSubmissionsTable
      submissionsType={submissionsType}
      newSubmissions={data?.recent_submissions || []}
      displayTeamMemberLocation
    />
    <div style={{ height: 16 }} />
    <NewMembersTable newEmployees={data?.team_members?.recent} />
  </Wrapper>
);

export default MultipleLocationView;
